import { Component } from "@angular/core";

@Component({
  selector: 'app-cadastro-menu',
  templateUrl: './cadastro-menu.component.html',
  styleUrls: ['./cadastro-menu.component.scss']
})
export class CadastroMenuComponent {

}